import React, { useEffect } from 'react';

// ── useReveal hook ──────────────────────────────────
export function useReveal() {
  useEffect(() => {
    const els = document.querySelectorAll('.reveal,.reveal-left,.reveal-right');
    const io  = new IntersectionObserver(
      entries => entries.forEach(e => { if (e.isIntersecting) { e.target.classList.add('visible'); io.unobserve(e.target); } }),
      { threshold: 0.1, rootMargin: '0px 0px -40px 0px' }
    );
    els.forEach(el => io.observe(el));
    return () => io.disconnect();
  }, []);
}

// ── PageHeader ──────────────────────────────────────
export function PageHeader({ tag, title, accent, sub }) {
  return (
    <div className="page-header">
      {/* Grid overlay */}
      <div className="absolute inset-0 pointer-events-none"
        style={{
          backgroundImage:'linear-gradient(rgba(0,255,255,0.02) 1px,transparent 1px),linear-gradient(90deg,rgba(0,255,255,0.02) 1px,transparent 1px)',
          backgroundSize:'80px 80px',
          maskImage:'radial-gradient(ellipse at center,black 30%,transparent 75%)',
          animation:'gridDrift 22s linear infinite',
          zIndex:0,
        }} />
      {/* Orbs */}
      <div className="absolute pointer-events-none rounded-full"
        style={{ width:400, height:400, top:-80, left:-80, background:'radial-gradient(circle,rgba(0,255,255,0.09) 0%,transparent 70%)', filter:'blur(80px)', animation:'orbFloat1 14s ease-in-out infinite', zIndex:0 }} />
      <div className="absolute pointer-events-none rounded-full"
        style={{ width:300, height:300, bottom:-60, right:-60, background:'radial-gradient(circle,rgba(139,92,246,0.09) 0%,transparent 70%)', filter:'blur(80px)', animation:'orbFloat2 17s ease-in-out infinite', zIndex:0 }} />

      <div className="container relative z-[1]">
        {tag && <div className="section-tag justify-center mb-3">{tag}</div>}
        <h1 className="page-header-title">
          {title}{' '}
          {accent && <span className="text-gradient">{accent}</span>}
        </h1>
        {sub && <p className="page-header-sub">{sub}</p>}
      </div>
    </div>
  );
}

// ── GlowDivider ─────────────────────────────────────
export function GlowDivider() {
  return (
    <div className="w-full h-px my-0"
      style={{ background:'linear-gradient(90deg,transparent,rgba(0,255,255,0.3) 30%,rgba(139,92,246,0.3) 70%,transparent)', boxShadow:'0 0 16px rgba(0,255,255,0.1)' }} />
  );
}

// ── StatCard ─────────────────────────────────────────
export function StatCard({ num, suffix, label }) {
  return (
    <div className="glass-card text-center px-8 py-10 reveal">
      <div className="font-display font-extrabold text-[3rem] tracking-[-0.05em] mb-2"
        style={{ background:'linear-gradient(135deg,#00ffff,#a78bfa)', WebkitBackgroundClip:'text', WebkitTextFillColor:'transparent', backgroundClip:'text', filter:'drop-shadow(0 0 20px rgba(0,255,255,0.25))' }}>
        {num}{suffix}
      </div>
      <p className="font-mono text-xs tracking-[3px] uppercase" style={{ color:'var(--text-3)' }}>{label}</p>
    </div>
  );
}
